// Cookie utility functions
export const setCookie = (name: string, value: string, days: number = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};

// Store client credentials in cookies
export const storeClientCredentials = (credentials: {
  dev?: {
    clientId: string;
    clientSecret?: string;
  };
  prod?: {
    clientId: string;
    clientSecret?: string;
  };
}) => {
  if (credentials.dev) {
    setCookie('dev_client_id', credentials.dev.clientId);
    if (credentials.dev.clientSecret) {
      setCookie('dev_client_secret', credentials.dev.clientSecret);
    }
  }
  if (credentials.prod) {
    setCookie('prod_client_id', credentials.prod.clientId);
    if (credentials.prod.clientSecret) {
      setCookie('prod_client_secret', credentials.prod.clientSecret);
    }
  }
};

// Get client credentials for specific environment
// Checks cookies first (from login), then env vars as fallback
export const getClientCredentials = (
  environment: 'DEV' | 'PROD'
): { clientId: string; clientSecret: string } | null => {
  const envPrefix = environment.toLowerCase();
  let clientId = getCookie(`${envPrefix}_client_id`);
  let clientSecret = getCookie(`${envPrefix}_client_secret`);

  if (!clientId && environment === 'DEV') {
    clientId = process.env.REACT_APP_DEV_CLIENT_ID || null;
    clientSecret = process.env.REACT_APP_DEV_CLIENT_SECRET || null;
  }
  if (!clientId && environment === 'PROD') {
    clientId = process.env.REACT_APP_PROD_CLIENT_ID || null;
    clientSecret = process.env.REACT_APP_PROD_CLIENT_SECRET || null;
  }

  if (clientId) {
    return { clientId, clientSecret: clientSecret ?? '' };
  }
  return null;
};

// Clear all client credentials
export const clearClientCredentials = () => {
  deleteCookie('dev_client_id');
  deleteCookie('dev_client_secret');
  deleteCookie('prod_client_id');
  deleteCookie('prod_client_secret');
};
